import { createNamedContext } from '@utils';
import { BrandThemingContextValue, SurveyThemingContextValue } from './interfaces';

export const BrandThemingContext = createNamedContext<BrandThemingContextValue>(undefined, 'Branding.Theming.Context');

export const SurveyThemingContext = createNamedContext<SurveyThemingContextValue>(undefined, 'Branding.SurveyTheming.Context');